document.addEventListener('DOMContentLoaded', function () {
  function getEls() {
    return {
      openBtn: document.querySelector('[data-open-mobile-filters="true"]'),
      panel: document.getElementById('MobileFiltersPanel')
    };
  }

  function setOpen(open) {
    var els = getEls();
    if (!els.panel) return;
    if (open) {
      els.panel.hidden = false;
      document.body.classList.add('mobile-filters-open');
    } else {
      els.panel.hidden = true;
      document.body.classList.remove('mobile-filters-open');
    }
  }

  function bind() {
    var els = getEls();
    if (els.openBtn && els.openBtn.dataset.mobileFiltersBound !== 'true') {
      els.openBtn.dataset.mobileFiltersBound = 'true';
      els.openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(true);
      });
    }

    if (els.panel && els.panel.dataset.mobileFiltersBound !== 'true') {
      els.panel.dataset.mobileFiltersBound = 'true';

      els.panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-mobile-filters-close]')) {
          e.preventDefault();
          setOpen(false);
          return;
        }

        if (e.target.closest('[data-mobile-filters-apply]')) {
          e.preventDefault();
          setOpen(false);
          return;
        }
      });
    }
  }

  bind();
  document.addEventListener('facet:updated', bind);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
});
